import { jsx, jsxs } from 'react/jsx-runtime';
import { P } from './Typography.js';
import { cssVar } from '../theme/variables.js';
import React__default from 'react';
import { styled, css } from 'styled-components';

const FieldHeader = styled.div.withConfig({
  displayName: "Field__FieldHeader",
  componentId: "sc-905af49f-0"
})([
  `display:inline-flex;flex-direction:column;gap:4px;`
]);
const FieldLabel = styled.label.withConfig({
  displayName: "Field__FieldLabel",
  componentId: "sc-905af49f-1"
})([
  `font-weight:500;font-size:14px;line-height:14px;color:`,
  `;`,
  ``
], cssVar["color-text-primary"], (p) => p.variant === "big-grey" && css([
  `font-weight:700;font-size:15px;line-height:18px;color:rgba(128,128,128,0.4);`
]));
const FieldDescription = styled(P).attrs((props) => {
  return {
    size: "sm",
    color: "tertiary",
    weight: 400,
    ...props
  };
}).withConfig({
  displayName: "Field__FieldDescription",
  componentId: "sc-905af49f-2"
})([
  ``
]);
const FieldGroup = styled.div.withConfig({
  displayName: "Field__FieldGroup",
  componentId: "sc-905af49f-3"
})([
  `display:flex;flex-direction:column;gap:1rem;`,
  ``
], (p) => p.gap === "sm" && css([
  `gap:0.375rem;`
]));
const ErrorMessageBase = styled.div.withConfig({
  displayName: "Field__ErrorMessageBase",
  componentId: "sc-905af49f-4"
})([
  `color:`,
  `;font-size:0.875rem;`
], cssVar["color-app-delete"]);
const ErrorMessage = ({ message }) => message ? /* @__PURE__ */ jsx(ErrorMessageBase, {
  children: message
}) : null;
const Composed = /* @__PURE__ */ React__default.forwardRef(({ label, description, ...props }, ref) => {
  return /* @__PURE__ */ jsxs(FieldGroup, {
    ...props,
    ref,
    children: [
      (label || description) && /* @__PURE__ */ jsxs(FieldHeader, {
        children: [
          label && /* @__PURE__ */ jsx(FieldLabel, {
            children: label
          }),
          description && /* @__PURE__ */ jsx(FieldDescription, {
            children: description
          })
        ]
      }),
      props.children
    ]
  });
});
Composed.displayName = "ComposedField";
const InputField = Object.assign(FieldGroup, {
  Description: FieldDescription,
  Label: FieldLabel,
  Header: FieldHeader,
  ErrorMessage,
  Composed
});

export { FieldDescription, FieldGroup, FieldHeader, FieldLabel, InputField };
//# sourceMappingURL=Field.js.map
